import { getMessage } from 'lib/translator'
import React from 'react'
import { Link } from 'react-router-dom'
import OrdersListViewNew from '../OrdersListView'
import PaymentDetails from '../PaymentDetails'
import PlacementDetails from '../PlacementDetails'
import './style.scss'

function ShowSaleOrderDetails({ saleOrderData, url, currency }) {
  if (!saleOrderData) {
    return null
  }

  const addresseeName =
    saleOrderData?.billingAddress?.metaData?.addresseeName ||
    [
      saleOrderData?.billingAddress?.metaData?.FirstName,
      saleOrderData?.billingAddress?.metaData?.LastName,
    ]
      .filter(Boolean)
      .join(' ') ||
    ''
  const customerId = saleOrderData?.customerId
  const hasNonZeroCustomerId =
    customerId !== 0 && customerId !== '0' && Number(customerId) !== 0
  const customerNameElement = addresseeName ? (
    hasNonZeroCustomerId ? (
      <Link
        className="customer-name"
        to={`${url}/customers/view/${customerId}`}
      >
        {addresseeName}
      </Link>
    ) : (
      <span className="customer-name" style={{ pointerEvents: 'none' }}>
        {addresseeName}
      </span>
    )
  ) : null

  return (
    <div className="sale-order-summary-wrapper">
      <div className="user-details">
        <PlacementDetails
          status={saleOrderData.status}
          creationTime={saleOrderData.createTime}
          device={saleOrderData.placedFrom}
        />
        <div className="address-details">
          <h3 className="customer-heading">{getMessage('Customer')}</h3>
          {customerNameElement}
        </div>
      </div>
      <OrdersListViewNew
        orders={saleOrderData.orders}
        status={saleOrderData.status}
        discounts={saleOrderData.discounts}
        standardServiceFee={saleOrderData.standardServiceFee}
        payments={saleOrderData.payments}
        currency={currency}
        totalAmount={saleOrderData.total}
        containerDepositSalesOrderAmount={saleOrderData?.containerDepositSalesOrderAmount || 0}
      />
      <PaymentDetails payments={saleOrderData.payments} currency={currency} />
    </div>
  )
}

export default ShowSaleOrderDetails
